// extracted by mini-css-extract-plugin
export default {"textTotal":"Total_textTotal__UKEll","textCount":"Total_textCount__Vdd80","mainCard":"Total_mainCard__TwYEy"};